import {useMutation} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';
import {EditorProject} from '@app/dashboard/project';
import {AxiosError} from 'axios';

export interface AiProjectPayload {
  prompt: string;
  details?: string;
  brand?: string;
  audience?: string;
  tone?: string;
}

export interface AiDebugInfo {
  status?: 'success' | 'error';
  provider?: string;
  model?: string;
  tokens?: number;
  elapsed_ms?: number;
  // error fields
  exception?: string;
  message?: string;
  file?: string;
  line?: number;
  api_key_set?: boolean;
  api_key_hint?: string | null;
  trace?: Array<{file: string; line: number; call: string}>;
}

export interface AiProjectResponse {
  project: EditorProject;
  tokensUsed: number;
  debug?: AiDebugInfo;
}

export function useAiProjectBuilder() {
  return useMutation<AiProjectResponse, AxiosError<{message: string; debug?: AiDebugInfo}>, AiProjectPayload>({
    mutationFn: payload =>
      apiClient.post<AiProjectResponse>('projects/ai', payload).then(r => r.data),
  });
}
